import type { Diamond } from '../api/types'

/**
 * Bundled sample stones — full live Heera inventory snapshot pulled
 * from the production mobile API on 2026-05-05. Uses the exact
 * pricing the mobile app shows (output of WebStockRate SP), so what
 * users see here matches what they'd see signed in on the mobile
 * app today.
 *
 * This file is the fallback when /api/search is unavailable. Once
 * Functions are deployed and the WebStockRate logic is ported to
 * TypeScript, the live API takes precedence and this serves only
 * during outages or as a public-preview catalog for anonymous users.
 *
 * Refresh this file whenever Heera inventory changes — re-run the
 * mobile API fetch, regenerate via scripts gen-stones-from-mobile.mjs.
 */

export const SAMPLE_STONES: Diamond[] = [
  {
    "stockId": "AJ0050",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "691542208",
    "carat": 0.8,
    "pricePerCarat": 142,
    "priceUSD": 114,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002542/AJH002542.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002542/AJH002542.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0052",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "692534553",
    "carat": 0.81,
    "pricePerCarat": 142,
    "priceUSD": 115,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002544/AJH002544.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002544/AJH002544.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0051",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "692534559",
    "carat": 0.83,
    "pricePerCarat": 141,
    "priceUSD": 117,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002543/AJH002543.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002543/AJH002543.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0053",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "691534901",
    "carat": 0.84,
    "pricePerCarat": 140,
    "priceUSD": 118,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002545/AJH002545.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002545/AJH002545.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0054",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Marquise",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Very Good",
    "symmetry": "Very Good",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "661402202",
    "carat": 0.82,
    "pricePerCarat": 156,
    "priceUSD": 128,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002546/AJH002546.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002546/AJH002546.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0049",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "698519059",
    "carat": 1.14,
    "pricePerCarat": 129,
    "priceUSD": 147,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002541/AJH002541.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002541/AJH002541.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0055",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "698560233",
    "carat": 1.32,
    "pricePerCarat": 118,
    "priceUSD": 156,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002549/AJH002549.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002549/AJH002549.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0056",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Emerald",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "641475853",
    "carat": 1.32,
    "pricePerCarat": 118,
    "priceUSD": 156,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002551/AJH002551.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002551/AJH002551.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0048",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Cushion",
    "color": "Fancy Vivid Yellow",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "695508381",
    "carat": 1.89,
    "pricePerCarat": 112,
    "priceUSD": 211,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH002538/AJH002538.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH002538/AJH002538.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0035",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": null,
    "carat": 1.63,
    "pricePerCarat": 131,
    "priceUSD": 213,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0042",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "D",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530430",
    "carat": 1.62,
    "pricePerCarat": 144,
    "priceUSD": 234,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001264/AJH001264.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001264/AJH001264.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0043",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "D",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530435",
    "carat": 1.62,
    "pricePerCarat": 144,
    "priceUSD": 234,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001265/AJH001265.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001265/AJH001265.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0041",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530437",
    "carat": 1.55,
    "pricePerCarat": 152,
    "priceUSD": 235,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001263/AJH001263.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001263/AJH001263.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0044",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530432",
    "carat": 1.84,
    "pricePerCarat": 142,
    "priceUSD": 262,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001266/AJH001266.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001266/AJH001266.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0047",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "D",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530431",
    "carat": 1.82,
    "pricePerCarat": 148,
    "priceUSD": 269,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001271/AJH001271.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001271/AJH001271.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0045",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "E",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530434",
    "carat": 2,
    "pricePerCarat": 145,
    "priceUSD": 290,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001268/AJH001268.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001268/AJH001268.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0046",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Round",
    "color": "D",
    "clarity": "VS1",
    "cut": "Ideal",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530433",
    "carat": 2.02,
    "pricePerCarat": 152,
    "priceUSD": 307,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001269/AJH001269.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001269/AJH001269.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0025",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "724578172",
    "carat": 2.01,
    "pricePerCarat": 155,
    "priceUSD": 312,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0036",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "E",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530428",
    "carat": 1.7,
    "pricePerCarat": 185,
    "priceUSD": 314,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001252/AJH001252.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001252/AJH001252.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0039",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530420",
    "carat": 1.81,
    "pricePerCarat": 183,
    "priceUSD": 331,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001258/AJH001258.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001258/AJH001258.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0024",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Pear",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "659463927",
    "carat": 2.05,
    "pricePerCarat": 162,
    "priceUSD": 333,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0028",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723536560",
    "carat": 2.5,
    "pricePerCarat": 134,
    "priceUSD": 334,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0026",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "719504961",
    "carat": 2.24,
    "pricePerCarat": 150,
    "priceUSD": 335,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0038",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "E",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530421",
    "carat": 1.8,
    "pricePerCarat": 188,
    "priceUSD": 338,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001257/AJH001257.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001257/AJH001257.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0027",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723551152",
    "carat": 2.26,
    "pricePerCarat": 152,
    "priceUSD": 344,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0040",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "E",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530425",
    "carat": 1.84,
    "pricePerCarat": 188,
    "priceUSD": 345,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001259/AJH001259.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001259/AJH001259.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0037",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "E",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "NONE",
    "lab": "IGI",
    "certNo": "678530427",
    "carat": 1.8,
    "pricePerCarat": 198,
    "priceUSD": 356,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJH001256/AJH001256.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJH001256/AJH001256.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0029",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723591074",
    "carat": 2.54,
    "pricePerCarat": 150,
    "priceUSD": 381,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0030",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723551163",
    "carat": 2.7,
    "pricePerCarat": 149,
    "priceUSD": 401,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0033",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "724578190",
    "carat": 2.55,
    "pricePerCarat": 167,
    "priceUSD": 425,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0034",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "724578191",
    "carat": 2.56,
    "pricePerCarat": 167,
    "priceUSD": 427,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0031",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723591588",
    "carat": 3.01,
    "pricePerCarat": 154,
    "priceUSD": 464,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0058",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Cushion",
    "color": "Fancy Vivid Yellow",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "732531409",
    "carat": 2.1,
    "pricePerCarat": 224,
    "priceUSD": 470,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJUSH316/AJUSH316.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJUSH316/AJUSH316.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0032",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "723551288",
    "carat": 3.07,
    "pricePerCarat": 154,
    "priceUSD": 473,
    "supplierId": null,
    "media": {
      "imageUrl": null,
      "videoUrl": null
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0059",
    "refStockId": null,
    "stoneType": "HPHT",
    "shape": "Oval",
    "color": "D",
    "clarity": "VVS1",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "GIA",
    "certNo": "6465793369",
    "carat": 5.02,
    "pricePerCarat": 1192,
    "priceUSD": 5984,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/NJS002/NJS002.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/NJS002/NJS002.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  },
  {
    "stockId": "AJ0057",
    "refStockId": null,
    "stoneType": "CVD",
    "shape": "Pear",
    "color": "Fancy Intense Yellow",
    "clarity": "VS2",
    "cut": "Excellent",
    "polish": "Excellent",
    "symmetry": "Excellent",
    "fluorescence": "None",
    "lab": "IGI",
    "certNo": "790691512",
    "carat": 31.04,
    "pricePerCarat": 900,
    "priceUSD": 27936,
    "supplierId": null,
    "media": {
      "imageUrl": "https://aska.co.in/aska/Diamonds/AJUSC18/AJUSC18.JPEG",
      "videoUrl": "https://aska.co.in/aska/Diamonds/AJUSC18/AJUSC18.MP4"
    },
    "measurements": {
      "length": 0,
      "width": 0,
      "height": 0,
      "ratio": 0
    },
    "tripleEx": false
  }
] as Diamond[]
